export default __webpack_public_path__ + "static/media/sample1.53ac041b.png";